import '../../index.css';
var styles = {
  "menuItemMainContent": "bp_menu_item_sections_module_menuItemMainContent--fe082",
  "label": "bp_menu_item_sections_module_label--fe082",
  "bold": "bp_menu_item_sections_module_bold--fe082",
  "description": "bp_menu_item_sections_module_description--fe082",
  "menuItemSideContent": "bp_menu_item_sections_module_menuItemSideContent--fe082",
  "textOnLightSecondary": "bp_menu_item_sections_module_textOnLightSecondary--fe082"
};
export { styles as default };